import React from "react"

class NewUserSuccess extends React.Component {
  constructor(props) {
    super(props)
  }

  copyToClipboard = (link) => {
    let selectText = link || ""
    let input = document.createElement("input")
    input.value = selectText
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }

  render() {
    return (
      <div>
        <div className="page-header">
          <i className="fas fa-check-double fa-lg"></i>
          <h3>Successfully Created New User</h3>
        </div>

        <h5>Password reset link below</h5>
        <p className="password-reset-url">{this.props.location.link || ''}</p>
        <button className="btn btn-outline-secondary" onClick={() => this.copyToClipboard(this.props.location.link)}>Copy Password Reset Link</button>
      </div>
    )
  }
}

export default NewUserSuccess
